import { MaskedLines, Reveal, Overline, GhostButton, scrollToId } from "./shared";

const APPLICATIONS = [
    "Hotel lobbies", "Corporate headquarters", "Luxury residences", "Restaurants",
    "Retail spaces", "Showrooms", "Airports", "Experience centres",
    "Museums", "Public spaces", "Wellness spaces",
];

export const Architects = () => (
    <section id="architects" data-testid="architects-section" className="relative border-t border-white/5 py-32 md:py-48">
        <div className="mx-auto grid max-w-[1600px] gap-16 px-6 md:px-12 lg:grid-cols-2 lg:gap-32">
            <div>
                <Overline>For Architects &amp; Interior Designers</Overline>
                <h2 className="mt-10 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl">
                    <MaskedLines lines={["Your next project", "deserves a signature."]} />
                </h2>
                <Reveal className="mt-10 max-w-lg">
                    <p className="text-lg font-light leading-relaxed text-white/60 md:text-xl">
                        We work alongside architects and designers to create bespoke kinetic elements that become part of the architecture itself — not objects placed in a space, but the reason the space is remembered.
                    </p>
                </Reveal>
                <Reveal delay={0.15} className="mt-12">
                    <GhostButton testId="architects-cta" onClick={() => scrollToId("contact")}>Design something with us</GhostButton>
                </Reveal>
            </div>
            <div className="flex flex-col justify-center">
                {APPLICATIONS.map((a, i) => (
                    <Reveal key={a} delay={i * 0.04} y={20}>
                        <div className="group flex items-baseline justify-between border-b border-white/8 py-4 transition-colors duration-500 hover:border-white/25">
                            <span className="text-base font-light tracking-wide text-white/65 transition-colors duration-500 group-hover:text-white md:text-lg">{a}</span>
                            <span className="font-mono-tech text-[10px] tracking-[0.3em] text-white/25">{String(i + 1).padStart(2, "0")}</span>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
